import React from 'react';
import { observer } from 'mobx-react';
import { InsuranceManagementListTemplate } from 'themes/application/insurance-management/pages';
import { setCurrentView } from 'core/utils';
import { InsuranceManagementListViewStore } from 'application/insurance-management/stores';

@setCurrentView((rootStore) => new InsuranceManagementListViewStore(rootStore), 'insuranceManagementListViewStore')
@observer
class InsuranceManagementList extends React.Component {
    render() {
        return <InsuranceManagementListTemplate {...this.props} />
    }
}

export default InsuranceManagementList;